import LearningManagerStore from 'Stores/LearningManagerStore';
import AssignUsersStore from 'Stores/AssignUsersStore';

const fromScope = <T>(
	scopes: string[],
	scope: string,
	fetch: () => Promise<T[]>
): Promise<T[]> =>
	scopes.includes(scope) ? fetch().catch(() => []) : Promise.resolve([]);

export const resolveAssignmentUserIds = async (
	learningManagerStore: LearningManagerStore,
	assignUsersStore: AssignUsersStore,
	assignmentId: number,
	scopes: string[]
): Promise<string[]> => {
	const [scopeUsers, groupUserIds] = await Promise.all([
		fromScope(scopes, 'users', () =>
			learningManagerStore.getAssignmentSourceScopeUsers(assignmentId)
		),
		fromScope(scopes, 'groups', () =>
			learningManagerStore.getAssignmentSourceScopeGroups(assignmentId)
		).then((groups) =>
			assignUsersStore
				.fetchUserIdsByGroups(groups.map((g) => g.id))
				.catch(() => [] as string[])
		)
	]);
	return [...new Set([...scopeUsers.map((u) => u.id), ...groupUserIds])];
};
